module.exports = __webpack_public_path__ + "static/img/triste.12d9833.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/triste.png
// module id = eh7s
// module chunks = 0